import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 10a3 3 0 1 0-6 0 3 3 0 0 0 6 0zm-3 5a5 5 0 0 0-4.975 4.5A8.958 8.958 0 0 0 12 21c1.84 0 3.55-.552 4.975-1.5A5 5 0 0 0 12 15zm11-3c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zm-6-2c0 1.521-.68 2.882-1.752 3.8a6.994 6.994 0 0 1 3.46 4.2 9 9 0 1 0-13.416 0 7 7 0 0 1 3.46-4.2A5 5 0 1 1 17 10z",
		fill: "currentColor"
	})
});
export default SvgUser;
